import React, {Fragment, useState, useEffect} from 'react'
import { Link } from "react-router-dom";
import axios from 'axios';


export const Recuperapass = (props) => {

    const [usuarioRegistrado, setusuarioRegistrado] = useState(false);
    const [passData, setPassData] = useState(null);
    const passChange = (val) => {
        setPassData(val.target.value)
    }
   
    const doRecupera = async () => {
        try {
            var dataForm = {
                "claveUsuario":window.location.search.split('code=')[1],
                "password":passData
            }
            let axiosConfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                  },  
              };
            await axios.post(`${process.env.REACT_APP_URL_API}auth/ModificarPassword`, dataForm, axiosConfig)
            .then(resLogin => {
                if(resLogin.status === 200){
                    if(resLogin.data === 'error'){
                    }else{

                        setusuarioRegistrado(true)
                       
                         // props.modaToggle(false)
                        // props.showRecoveryToggle(false)
                        // props.showRegistroToggle(false)   
                        
                    }
                }else{
                }

            })
              
        } catch (error) {
           
        }
    }

    return(
    <Fragment>
        <div id="logincontain">
            <div className="row">
                <div className="col-lg-6 col-md-6 mx-auto" id="column-left">
                    <img src={`${process.env.PUBLIC_URL}/assets/images/foto_registro.png`} className="img-responsive" alt="Curso Upta" />			
                </div>
                <div className="col-lg-6 col-md-6 mx-auto" id="column-right">
                    <Link to="/">
                        <img src={`${process.env.PUBLIC_URL}/assets/images/UPTA_logo.png`} alt="UPTA logo" />
                    </Link>
                    <p className="form-text text-muted">introduce tu nueva contraseña</p>
                    {!usuarioRegistrado ? 
                    <form onSubmit={(e) =>{ e.preventDefault(); doRecupera()}}>
                    <div className="form-group">
                        <input type="password" className="form-control" placeholder="Contraseña"  onChange={ passChange } />
                    </div>
                    
                    <button type="submit" id="resetpass" className="btn btn-primary">RESTABLECER CONTRASEÑA</button>
                    </form>
                    :
                    <Fragment>
                        <h3>Tu contraseña se ha actualizado</h3>
                        <Link className="btn btn-primary" to="/">Aceptar</Link>
                    </Fragment>
                   
                    }
                    <p className="form-text text-muted">© UPTA Unión de Profesionales y Trabajadores Autónomos</p>
                </div>	
            </div>			
        </div>
    </Fragment>
    )

}